export default {
  site_title: "OOPBUY Spreadsheet Guide",
  site_subtitle: "Die umfassendste deutsche Plattform für OOPBUY Spreadsheet",
  nav_home: "Startseite",
  nav_categories: "Kategorien",
  nav_guides: "Guides",
  nav_comparison: "Vergleich",
  nav_security: "Sicherheit",
  hero_line1: "OOPBUY Spreadsheet",
  hero_line2: "Die deutsche",
  hero_line3: "Produktliste & Guide",
  hero_cta: "Zum OOPBUY Spreadsheet",
  hero_tagline: "FINDE. VERGLEICHE. KAUFE.",
  categories_title: "Beliebte Kategorien",
  categories_subtitle: "Entdecke alle Kategorien und finde die besten Produkte schneller",
  category_discover: "Jetzt entdecken",
  cta_title: "oopbuy spreadsheet",
  cta_button: "buy it now",
  cta_right_text1: "Erhalte Zugriff auf alle Kategorien.",
  cta_right_text2: "Schneller einkaufen mit dem Spreadsheet.",
  articles_label: "Content Hub",
  articles_title: "OOPBUY Spreadsheet Guides",
  article_date: "Juli 2026",
  article_read: "Lesezeit",
  article_read_more: "Weiterlesen",
  features_label: "Warum wir?",
  features_title1: "Schneller finden.",
  features_title2: "Besser vergleichen.",
  features_subtitle: "Mit unserem Guide navigierst du durch alle Kategorien.",
  feature1_title: "Produktübersicht",
  feature1_desc: "Alle Kategorien übersichtlich in einem Spreadsheet sortiert.",
  feature2_title: "Zeitersparnis",
  feature2_desc: "Finde Produkte um ein Vielfaches schneller als mit der normalen Suche.",
  feature3_title: "Deutsche Anleitung",
  feature3_desc: "Komplett auf Deutsch erklärt, Schritt für Schritt verständlich.",
  brand_subtitle: "Unabhängiges Informationsportal",
  brand_title1: "Die umfassendste",
  brand_title2: "deutsche Plattform für",
  brand_title3: "OOPBUY Spreadsheet",
  brand_cta1: "Zum Hauptshop",
  brand_cta2: "Alle Kategorien",
  trust1: "Produktlisten",
  trust2: "QC-Fotos",
  trust3: "Versand DE",
  trust4: "Sicherheit",
  trust5: "Updates",
  footer_description: "Dein unabhängiger deutscher Guide für OOPBUY Spreadsheet. Schneller Produkte finden, besser vergleichen, sicherer einkaufen.",
  footer_products: "Produkte",
  footer_guides_title: "Guides",
  footer_support: "Support",
  footer_motto1: "Schneller.",
  footer_motto2: "Besser.",
  footer_motto3: "Sicherer.",
  footer_subscribe_text1: "Bleib auf dem Laufenden",
  footer_subscribe_text2: "Erhalte die neuesten Updates.",
  footer_subscribe_placeholder: "Deine E-Mail-Adresse",
  footer_subscribe_btn: "Abonnieren",
  footer_copyright: "Alle Rechte vorbehalten.",
  back_to_home: "← Zurück zur Startseite",
  article_breadcrumb: "Startseite",
  article_related: "Verwandte Guides",
  article_cta_title: "Bereit für OOPBUY Spreadsheet?",
  article_cta_text1: "Jetzt alle Kategorien entdecken",
  article_cta_text2: "und schneller einkaufen.",
  article_date_full: "15. Juli 2026",
  article_category_tag: "Guide",
  article_author: "OOPBUY Spreadsheet Team",
  dropdown_placeholder: "Kategorie wählen...",
  internal_links_title: "Weitere Ressourcen",
  hero_search_placeholder: "Suche nach OOPBUY Spreadsheet Kategorien...",
  section1_title: "Was ist ein OOPBUY Spreadsheet?",
  section1_text1: "Ein OOPBUY Spreadsheet ist eine umfassende, strukturierte Produktliste, die alle verfügbaren Kategorien und Artikel übersichtlich darstellt. Anders als die normale Produktsuche ermöglicht das Spreadsheet einen schnellen Überblick über das gesamte Sortiment und erleichtert den Vergleich zwischen verschiedenen Produkten erheblich.",
  section1_text2: "Das Spreadsheet wird regelmäßig aktualisiert und enthält detaillierte Informationen zu jeder Produktkategorie. Von Schuhen über Bekleidung bis hin zu Accessoires — alle wichtigen Kategorien sind in einer einzigen, einfach zu navigierenden Übersicht zusammengefasst.",
  section1_table_header1: "Methode",
  section1_table_header2: "Geschwindigkeit",
  section1_table_header3: "Übersicht",
  section1_table_header4: "Anfängerfreundlich",
  section1_method1: "Normale Suche",
  section1_method2: "Einzelne Links",
  section1_method3: "OOPBUY Spreadsheet",
  section2_title: "Warum nutzen immer mehr Nutzer ein OOPBUY Spreadsheet?",
  section2_card1_title: "Produktübersicht",
  section2_card1_desc: "Alle Kategorien auf einen Blick, keine versteckten Produkte.",
  section2_card2_title: "Kategorien",
  section2_card2_desc: "Übersichtlich nach Produkttypen sortiert für schnelle Navigation.",
  section2_card3_title: "Zeitersparnis",
  section2_card3_desc: "Vergleiche mehrere Produkte gleichzeitig ohne hin und her zu klicken.",
  section2_card4_title: "Bessere Organisation",
  section2_card4_desc: "Strukturierte Listen helfen dir, den Überblick zu behalten.",
  section3_title: "So funktioniert OOPBUY Spreadsheet",
  section3_step1_title: "Kategorie auswählen",
  section3_step1_desc: "Wähle aus 14 übersichtlichen Kategorien die passende für dich aus.",
  section3_step2_title: "Produkt vergleichen",
  section3_step2_desc: "Vergleiche Produkte direkt nebeneinander und finde die besten Optionen.",
  section3_step3_title: "Informationen prüfen",
  section3_step3_desc: "Überprüfe alle wichtigen Details wie Preise, Verfügbarkeit und Bewertungen.",
  section3_step4_title: "Bestellung vorbereiten",
  section3_step4_desc: "Mit allen notwendigen Informationen kannst du deine Bestellung sicher aufgeben.",
  section4_title: "Vergleichsbereich",
  section4_function: "Funktion",
  section4_spreadsheet: "OOPBUY Spreadsheet",
  section4_normal: "Normale Suche",
  section4_row1: "Kategorien",
  section4_row2: "Filter",
  section4_row3: "Übersicht",
  section4_row4: "Zeitersparnis",
  section4_row3_val1: "Hoch",
  section4_row3_val2: "Niedrig",
  section4_row4_val1: "Sehr hoch",
  section4_row4_val2: "Niedrig",
  section5_title: "Ist OOPBUY sicher?",
  section5_text: "Sicherheit ist ein zentrales Anliegen beim Online-Shopping. Mit OOPBUY hast du Zugriff auf verifizierte Verkäufer und geprüfte Produktinformationen. QC-Bilder (Qualitätskontrollbilder) helfen dir, die Produktqualität vor dem Versand zu überprüfen. Deine persönlichen Daten sind durch moderne Verschlüsselungstechnologien geschützt. Wir empfehlen, immer die Verkäuferbewertungen zu prüfen und bei Unklarheiten den Kundenservice zu kontaktieren.",
  section5_disclaimer: "Diese Website ist ein unabhängiges Informationsportal und steht nicht offiziell mit OOPBUY in Verbindung.",
  category_shoes: "Shoes",
  category_hoodies: "Hoodies/Sweaters",
  category_tshirts: "T-Shirts",
  category_jackets: "Jackets",
  category_pants: "Pants/Shorts",
  category_headwear: "Headwear",
  category_sets: "Sets",
  category_underwear: "Underwear/Underpants",
  category_jersey: "Jersey",
  category_accessories: "Accessories",
  category_bags: "Bags",
  category_belts: "Belts",
  category_perfumes: "Perfumes",
  category_other: "Other Stuff",
  article_h1_line1: "OOPBUY Spreadsheet",
  article_h1_line2: "Der komplette Guide",
  article_h1_line3: "für Deutschland",
  article_meta_date: "15. Juli 2026",
  article_meta_author: "OOPBUY Spreadsheet Team",
  article_meta_category: "Guide",
  article_meta_readtime: "Lesezeit: 12 Minuten",
};